export const IMAGE_ENDPOINTS = {
  CONVERT: "/convert",
  OPTIMIZE: "/optimize",
  HEALTH: "/health",

  // Optimizers
  OPTIMIZE_TWITTER: "/optimize/twitter",
  OPTIMIZE_WEB: "/optimize/web",
  OPTIMIZE_INSTAGRAM: "/optimize/instagram",
  OPTIMIZE_YOUTUBE_THUMBNAIL: "/optimize/youtube-thumbnail",
  OPTIMIZE_SEO_RESPONSIVE: "/optimize/seo-responsive",
  OPTIMIZE_WHATSAPP: "/optimize/whatsapp",
  OPTIMIZE_CUSTOM: "/optimize/custom",

  // Analyzers
  ANALYZE: "/analyze",
  IMAGE_AUTHENTICITY_CHECKER: "/image-authenticity-checker",
  IMAGE_SHARPEN: "/image-sharpen",

  // svg optimizers
  SVG_OPTIMIZE: "/optimize-svg",

  // Cropping
  CROP: "/crop",

  // Resizing
  RESIZE: "/resize",

  // Base64
  IMAGE_TO_BASE64: "/to-base64",
  BASE64_TO_IMAGE: "/from-base64",

  //Favicon Generator
  FAVICON: "/favicon",

  //HEIC Converter
  HEIC_TO_IMAGE: "/heic-to-image",
  IMAGE_TO_HEIC: "/image-to-heic",

  //WATERMARK
  WATERMARK_IMAGE: "/watermark-image",

  // Image color effect
  IMAGE_COLOR_EFFECT: "/image-color-effect",

  // EXif Scrubber
  EXIF_SCRUBBER: "/exif-scrubber",

  // Image DPI Changer
  IMAGE_DPI_CHANGER: "/image-dpi-changer",
  IMAGE_DPI_CHECKER: "/image-dpi-checker",

  // Password Generator
  PASSWORD_GENERATOR: "/secure-password-generator",
  UUID_GENERATOR: "/uuid-generator",
  ENCRYPT: "/encrypt",
  DECRYPT: "/decrypt",

  // GIF CONVERTER
  VIDEO_TO_GIF: "/video-to-gif",
  IMAGE_TO_GIF: "/image-to-gif",

  // STICKER GENERATOR
  VIDEO_TO_STICKER: "/video-to-sticker",
  IMAGE_TO_STICKER: "/image-to-sticker",
} as const;

export const RUST_PDF_ENDPOINTS = {
  PDF_VALIDATE: "/pdf/validate",

  // PDF Compressor
  PDF_COMPRESS: "/pdf/optimize",
  PDF_COMPRESS_PRO: "/pdf/optimize",

  // PDF DPI
  PDF_DPI_CHECKER: "/pdf/dpi-checker",
  PDF_DPI_CHANGER: "/pdf/dpi-changer",
  PDF_ANALYSIS: "/pdf/analysis",

  // PDF Password
  PDF_ADD_PASSWORD: "/pdf/add-password",
  PDF_REMOVE_PASSWORD: "/pdf/remove-password",

  //Image to PDF Converter
  IMAGE_TO_PDF: "/pdf/images-to-pdf",
  PDF_TO_IMAGE: "/pdf/pdf-to-images",

  // PDF EXTRACTOR
  EXTRACT_PDF_IMAGES: "/pdf/pdf-extract-images",

  // PDF text and markup conversions
  PDF_TO_TEXT: "/pdf/pdf-to-text",
  PDF_TO_SVG: "/pdf/pdf-to-svg",
  PDF_TO_HTML: "/pdf/pdf-to-html",
  PDF_TO_MARKDOWN: "/pdf/pdf-to-markdown",

  // PDF format conversion
  PDF_CONVERT_FORMAT: "/pdf/pdf-convert-format",
} as const;

export const WEB_ENDPOINTS = {
  // Auth
  register: "/auth/register",
  login: "/auth/login",
  refreshToken: "/auth/refresh-token",
  logout: "/auth/logout",

  // blog
  blog_list: "/blog/news",
  blog_details: "/blog/news/",
  blog_featured: "blog/news/featured",
  blog_exclusive: "/blog/news/exclusive",
  // blog_category: "/blog/news/category",
  blog_search: "/blog/news/search",

  // blog category
  blog_category_list: "/blog/categories",
  blog_category_details: "/blog/categories/",
  blog_category_top: "/blog/categories/top",

  //contact us
  create_contact_message: "/public/contact",

  // app logs
  create_app_log: "/logs",
} as const;
